import axios from '@/api/client';

const state = {
  rankings: null,
  ranking: null
};

const getters = {
  stateRankings: state => state.rankings,
  stateRanking: state => state.ranking,
};

const actions = {


  //liefert nur zu angemeldetem User
  async getRanking({commit}, payload = null) {


    //const asString2 = new URLSearchParams(payload).toString();

    //const url = 'tracks?downsamplefaktor=3&tracks_serial=' + payload.get("tracks_serial")  //tut aber warum nicht mit Parameter...?
    const userId = typeof payload === "object" && payload !== null ? payload.user_id : null;
    const url = userId ? `rankings?user_id=${encodeURIComponent(userId)}` : 'rankings'
    //const {data} = await axios.post(url)
    let {data} = await axios.get(url);
    console.log('--->received:',data)

    if (!payload || payload.commit !== false) commit('setRankings', data);
    return data;
  },





};

const mutations = {
  setRankings(state, rankings){
    state.rankings = rankings;
  },
  setRanking(state, ranking){
    state.ranking = ranking;
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};
